import Modal from "/WebInterface/new-ui/modules/modal.js";
import { t } from "/WebInterface/new-ui/modules/localizations/localizations.js";
import {
  quickShareTemplate,
  errorResponseTemplate,
} from "/WebInterface/new-ui/modules/modals/quick-share/template.js";
import { _$ } from "/WebInterface/new-ui/assets/js/utils/dom.js";

export const initQuickShare = (response, obj, names) => {
  let errorMessage = utils.textEncode(
    utils.sanitizePure(utils.decodeURILocal(response?.message))
  );

  const hasErrorInResponse =
    errorMessage?.toLowerCase().indexOf("error") >= 0 && !response?.username;

  if (
    errorMessage.indexOf("ERROR") == 0 &&
    errorMessage.indexOf("email_failed") > 0
  ) {
    errorMessage = t("sendingEmailFailed");
  }

  let buttons = [
    {
      label: "ok",
      close: true,
      classes: [""],
      onClick: () => {},
    },
  ];

  const shareWindowNoOpenInEmail = utils.getUserCustomizationValue(
    "shareWindowNoOpenInEmail"
  );
  const shareHideCopyLinkButton = utils.getUserCustomizationValue(
    "shareHideCopyLinkButton"
  );
  const shareWindowNoUserInfoAfterShare = utils.getUserCustomizationValue(
    "shareWindowNoUserInfoAfterShare"
  );
  const hideShareResultLink = utils.getUserCustomizationValue(
    "hideShareResultLink"
  );

  if (!hasErrorInResponse) {
    if (!shareWindowNoOpenInEmail) {
      buttons.unshift({
        label: "openInEmailClient",
        classes: ["primary-button", "is-bordered", "mr-2"],
        id: "openInEmailClient-quick-share",
        onClick: () => {
          const emailToClient = utils
            .decodeURILocal(response.message)
            .match(/href="([^"]*)/)[1];
          const link = utils.getEmailClientLink(emailToClient, [
            { varToReplace: "{files}", value: names ? names : obj.paths },
          ]);
          window.open(
            link.replace(/\r/g, "%0D%0A").replace(/%3Cbr%3E/gi, "%0D%0A"),
            "_blank"
          );
        },
      });
    }

    if (!shareHideCopyLinkButton && !obj.shareUsernames) {
      buttons.unshift({
        label: "copyLinkToClipboard",
        close: true,
        classes: ["primary-button", "is-bordered", "mr-2"],
        onClick: () => {
          navigator.clipboard.writeText(utils.decodeURILocal(response.url));
          growl(t("linkCopiedToClipboard"), "", 5000);
        },
      });
    }
  }

  const emailToClient = utils
    .decodeURILocal(response.message)
    .match(/href="([^"]*)/)[1];
  new Modal({
    title: hasErrorInResponse ? t("publishFailed") : t("publishCompleted"),
    body: hasErrorInResponse
      ? errorResponseTemplate({ errorMessage })
      : quickShareTemplate({
          shareUsernames: obj?.shareUsernames,
          shareWindowNoUserInfoAfterShare,
          hideShareResultLink,
          emailToClient,
          username: response?.username,
          password: response?.password,
          url: utils.decodeURILocal(response?.url),
        }),
    uniqueId: "quick-share-modal",
    extraClasses: ["quick-share-modal"],
    minWidth: "650px",
    minHeight: "350px",
    buttons,
    movable: true,
    backdrop: false,
    animate: false,
  });

  const quickShareOpenEmailClient = utils.getUserCustomizationValue(
    "quickShareOpenEmailClient"
  );
  if (quickShareOpenEmailClient) {
    _$("#modal-btn-openInEmailClient-quick-share").el()?.click();
  }

  _$("#copyLinkToClipboardQuickShare").on("click", () => {
    navigator.clipboard.writeText(utils.decodeURILocal(response.url));
    growl(t("linkCopiedToClipboard"), "", 5000);
  });
};
